import { apiClient } from ".";
import { useQuery } from "@tanstack/react-query";

export const getLoginStatus = async ({ id }: { id: string }) => {
  const response = await apiClient({
    url: `/auth/auth`,
    method: "GET",
    params: {
      id,
    },
  });
  return response.data;
};

export const useGetLoginStatus = ({
  id,
  enabled,
}: {
  id: string;
  enabled: boolean;
}) => {
  const loginStatusQuery = useQuery({
    queryKey: ["get-login-status"],
    queryFn: () => getLoginStatus({ id }),
    retry: false,
    refetchInterval: 1500,
    enabled,
    staleTime: Infinity,
  });
  return loginStatusQuery;
};
